import React from 'react';
import { TrackingPropsInterface } from '@marriott/mi-ui-library';

export enum ALinkStandaloneSize {
  Small = 'Small',
  Medium = 'Medium',
  ExtraSmall = 'ExtraSmall',
}

interface ALinkStandalonePropsBase {
  text?: string;
  children?: React.ReactNode;
  size?: ALinkStandaloneSize;
  trackingProperties?: TrackingPropsInterface;
  custom_click_track_value?: string;
  preTrackVal?: string;
}

export interface ALinkStandaloneAnchorProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  /** Link URL from AEM model. Takes precedence over `href`. */
  ctaLink?: string;
  href?: string;

  /** @deprecated Prefer `openInANewTab`. */
  externalLink?: boolean | 'true' | 'false';

  /** Whether the link opens in a new tab. Accepts boolean or string "true". Takes precedence over `externalLink`. */
  openInANewTab?: boolean | 'true' | 'false';

  /** Accessible text for the external link icon. Defaults to `'opens in a new window'`. */
  openInANewTabText?: string;
}

export interface ALinkStandaloneButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  ctaLink?: undefined;
  href?: undefined;
  type?: 'button' | 'reset' | 'submit';
}

export type ALinkStandaloneProps = (ALinkStandaloneAnchorProps | ALinkStandaloneButtonProps) &
  ALinkStandalonePropsBase;
